import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../../components/Common/SectionTitle";
import hireTalentImg from "../../assets/img/hire1.png";
import AOS from "aos";

const HireTalentSection = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <section
      className="rs-hire-talent-section position-relative pt-120 pb-100 md-pt-90 md-pb-70"
      style={{ backgroundColor: "#fff" }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-lg-6 mb-40 md-mb-0"
            data-aos="fade-up"
            data-aos-duration="1200"
          >
            <div style={{ marginBottom: 24 }}>
              <span
                style={{
                  display: "inline-block",
                  background: "#ffc107",
                  color: "#222",
                  fontWeight: 700,
                  borderRadius: 24,
                  padding: "6px 20px",
                  fontSize: 15,
                  letterSpacing: 1,
                  boxShadow: "0 2px 8px rgba(255,193,7,0.08)",
                  marginBottom: 12,
                }}
              >
                <i className="fa fa-star" style={{ marginRight: 8 }}></i>
                Join SyrolX – Syrol Experts
              </span>
            </div>
            <h2 style={{ fontWeight: 800, fontSize: 36, marginBottom: 18, color: "#222" }}>
              Hire Top Talent or <span style={{ color: "#ffc107" }}>Get Hired</span> by Leading Companies
            </h2>
            <p style={{ fontSize: 18, color: "#444", marginBottom: 32, maxWidth: 500 }}>
              SyrolX connects businesses with elite professionals and empowers experts to join a trusted network. Whether you need to hire, get hired, or join our expert community, SyrolX is your gateway to opportunity and growth.
            </p>
            <div style={{ display: "flex", gap: 18, flexWrap: "wrap" }}>
              {/* <Link
                className="readon"
                to="/hire-talent"
                style={{ display: "inline-flex", alignItems: "center", fontWeight: 600, fontSize: 17 }}
              >
                <i className="fa fa-briefcase" style={{ marginRight: 8 }}></i>
                Hire Talent
              </Link> */}
              {/* <Link to="https://experts.syroltech.com">Job Opening</Link> */}
              <Link
                className="readon2"   
                to="https://experts.syroltech.com"
                style={{ display: "inline-flex", alignItems: "center", fontWeight: 600, fontSize: 17 }}
              >
                <i className="fa fa-user" style={{ marginRight: 8 }}></i>
                Join SyrolX
              </Link>
              {/* <Link
                className="readon2"
                to="/syrolx"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  fontWeight: 600,
                  fontSize: 17,
                  background: "#222",
                  color: "#ffc107",
                  border: "none",
                  marginLeft: 0,
                }}
              >
                <i className="fa fa-star" style={{ marginRight: 8 }}></i>
                Join SyrolX
              </Link> */}
            </div>
          </div>
          <div
            className="col-lg-6 d-flex justify-content-center position-relative"
            data-aos="fade-left"
            data-aos-duration="1200"
          >
            <div style={{ position: "relative", width: "100%", maxWidth: 600, background: "transparent" }}>
              <img
                src={hireTalentImg}
                alt="Hire Talent or Find a Job"
                style={{
                  width: "100%",
                  borderRadius: 0,
                  border: "none",
                  objectFit: "cover",
                  minHeight: 500,
                  maxHeight: 650,
                  filter: "brightness(0.96)",
                  background: "transparent"
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HireTalentSection; 